/***
 * 创建人：yuanjs
 * 时间：2019-06-10
 * 描述：对QQ进行验证
 * 更新记录: 
 */
import { Directive } from '@angular/core';
import { NG_VALIDATORS, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[ValidatorQQ]',
  providers:[{provide:NG_VALIDATORS,useExisting:ValidatorQqDirective,multi:true}]
})
export class ValidatorQqDirective {

  constructor() { }
  validate(control:AbstractControl):any{
    let valid:boolean = false
    var reg = /^[1-9][0-9]{4,14}$/
    if(control.value){
      valid = reg.test(control.value)
    } else{
      valid = true  //为空时,不校验
    }
    return valid ? null:  {ValidatorQQ:"由5到15位数字组成,最小为10000"} 
  }
}
